export const contactWrapperData = [
  {
    mainLetter: "A",
    contactData: [
      {
        image: "avtar/3.jpg",
        name: "Andres Williamson",
        phoneNumber: "191-900-5689",
      },
    ],
  },
  {
    mainLetter: "B",
    contactData: [
      {
        image: "blog/blog-3.jpg",
        name: "Britlin Weed",
        phoneNumber: "698-781-5581",
      },
      {
        imageUser: "BD",
        color: "info",
        name: "Brendra Dixit",
        phoneNumber: "589-789-2563",
      },
    ],
  },
  {
    mainLetter: "C",
    contactData: [
      {
        image: "blog/14.png",
        name: "Cody Fisher",
        phoneNumber: "983-333-4545",
      },
      {
        imageUser: "CE",
        color: "success",
        name: "Clifford Evans",
        phoneNumber: "321-456-7878",
      },
      {
        imageUser: "CW",
        color: "warning",
        name: "Cameron Williamson",
        phoneNumber: "369-852-7417",
      },
    ],
  },
  {
    mainLetter: "D",
    contactData: [
      {
        image: "blog/12.png",
        name: "Darlene Robertson",
        phoneNumber: "231-279-1001",
      },
      {
        image: "user/3.png",
        name: "Dianne Russell",
        phoneNumber: "569-789-1002",
      },
      {
        image: "user/6.jpg",
        name: "Darrell Steward",
        phoneNumber: "200-300-1030",
      },
    ],
  },
  {
    mainLetter: "E",
    contactData: [
      {
        image: "user/1.jpg",
        name: "Emily Collins",
        phoneNumber: "100-555-7032",
      },
    ],
  },
  {
    mainLetter: "F",
    contactData: [
      {
        image: "user/2.jpg",
        name: "Fiona Cooper",
        phoneNumber: "362-778-1919",
      },
      {
        imageUser: "FG",
        color: "danger",
        name: "Freya Grayson",
        phoneNumber: "589-789-2563",
      },
    ],
  },
  {
    mainLetter: "G",
    contactData: [
      {
        imageUser: "GE",
        color: "warning",
        name: "Gabriel Evans",
        phoneNumber: "963-147-5024",
      },
    ],
  },
];

export const groupChatHeader = [
  "avtar/16.jpg",
  "avtar/4.jpg",
  "avtar/7.jpg",
  "avtar/11.jpg",
  "avtar/4.jpg",
  "blog/comment.jpg",
  "avtar/7.jpg",
];
